import React from 'react';
import {TProvider} from '../../i18n/i18n';
import FFDropdownList from '../FFDropdownList';
import {stylesheet} from 'typestyle';

interface AbsoluteOrRelativeDropdownProps {
    isAbsolute: boolean;
    setIsAbsolute: (value: boolean) => void;
}

export const AbsoluteOrRelativeDropdown: React.FunctionComponent<AbsoluteOrRelativeDropdownProps> = (props) => (
    <TProvider>
        {(t) => (
            <FFDropdownList
                className={absRelCss.list}
                listItems={[
                    {value: 'absolute', text: t('chart:absoluteText')},
                    {
                        value: 'relative',
                        text: t('chart:relativeText'),
                    },
                ]}
                selectedValue={props.isAbsolute ? 'absolute' : 'relative'}
                selectedValueChanged={(value) => props.setIsAbsolute(value === 'absolute')}
            />
        )}
    </TProvider>
);

const absRelCss = stylesheet({
    list: {
        display: 'inline-block',
    },
});



// WEBPACK FOOTER //
// ./src/views/ExplorerParamsBar/AbsoluteOrRelativeDropdown.tsx